import { Button, Grid, LinearProgress } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Alert from "@material-ui/lab/Alert";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";

const AuthForm = ({
  children,
  initialValues,
  validate,
  onSubmit: onSubmitProp,
  formTitle,
  errorMessage,
  bottomLinks,
  submitBtnTitle,
  formRef,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isErrorVisible, setIsErrorVisible] = useState(false);

  useEffect(() => {
    if (errorMessage) {
      setIsErrorVisible(true);
      setIsSubmitting(false);
    } else setIsErrorVisible(false);
  }, [errorMessage]);

  const onSubmit = (values) =>
    Promise.resolve()
      .then(() => setIsSubmitting(true))
      .then(() => onSubmitProp(values));

  return (
    <Grid container justify="center" alignItems="center" style={{ height: "100vh" }}>
      <Card style={{ width: 320 }}>
        <CardContent>
          <Formik
            innerRef={formRef}
            initialValues={initialValues}
            validate={validate}
            onSubmit={onSubmit}
          >
            {({ submitForm }) => (
              <Form>
                <Typography
                  variant="h6"
                  style={{ marginBottom: 16, textAlign: "center" }}
                >
                  {formTitle}
                </Typography>

                {children}

                <Grid
                  container
                  justify="flex-end"
                  direction="column"
                  style={{ marginTop: "16px" }}
                >
                  {isSubmitting && <LinearProgress />}

                  <Collapse in={isErrorVisible} style={{ margin: "16px 0" }}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => setIsErrorVisible(false)}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {errorMessage}
                    </Alert>
                  </Collapse>

                  <Button
                    variant="contained"
                    color="primary"
                    disabled={isSubmitting}
                    onClick={submitForm}
                  >
                    {submitBtnTitle}
                  </Button>

                  {bottomLinks()}
                </Grid>
              </Form>
            )}
          </Formik>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default AuthForm;
